import AppConfig, { IS_DEVELOPMENT_ENV } from '../AppConfig';
import { EHealthCheckupBookingStatus } from '../types';

interface ITicketProps {
  nodeId: string;
  articleId: string;
  category: string;
  subCategory?: string; // Make subCategory optional
  title: string;
}

export const MIXPANEL_EVENTS = {
  RAISE_A_TICKET_CLICKED: 'employee-help-center-raise-a-ticket-clicked',
  TICKET_SUBMITTED: 'employee-help-center-raise-a-ticket-submitted',
  TICKET_SUBMITTED_SUCCESS:
    'employee-help-center-raise-a-ticket-submitted-successful',
  TICKET_SUBMITTED_FAILURE:
    'employee-help-center-raise-a-ticket-submitted-failure',
  IMTC_TICKET_SUBMITTED: 'employee-help-center-imtc-raise-a-ticket-submitted',
  IMTC_TICKET_SUBMITTED_SUCCESS:
    'employee-help-center-raise-a-ticket-submitted-imtc-successful',
  IMTC_TICKET_SUBMITTED_FAILURE:
    'employee-help-center-raise-a-ticket-submitted-imtc-failure',
  RAISE_A_TICKET_CANCELLED: 'employee-help-center-raise-a-ticket-cancel',
  IMTC_RAISE_A_TICKET_CANCELLED: 'employee-help-center-imtc-raise-a-ticket-cancel',
  CALL_US_BANNER_CLICKED: 'employee-help-center-call-us-banner-clicked',
  CLAIMS_VIEW_ALL_CLICKED: 'employee-help-center-claims-view-all-cards',
  TELEHEALTH_VIEW_ALL_CLICKED: 'employee-help-center-telehealth-view-all-card',
  ENTER_CLAIMS_CHAT: 'employee-help-center-claims-chat',
  ENTER_TELEHEALTH_CHAT: 'employee-help-center-telehealth-chat',
  ENTER_STU_CHAT: 'employee-help-center-stu-bot-chat',
  HEALTHCHECKUP_VIEW_ALL_CLICKED: 'employee-help-center-healthcheckup-view-all-card',
  ENTER_HEALTHCHECKUP_CHAT: 'employee-help-center-healthcheckup-chat',
  ENTER_HEALTH_CARD_CHAT: 'employee-help-center-health-card-chat',
  ENTER_DEPENDENTS_CHAT: 'employee-help-center-dependents-chat',
  MAIN_CATEGORY_CLICKED: 'employee-help-center-main-category-clicked',
  SUB_CATEGORY_CLICKED: 'employee-help-center-sub-category-clicked',
  ARTICLE_VIEWED: 'employee-help-center-article-viewed',
  FEEDBACK_SHOWN: 'employee-help-center-feedback-shown',
  FEEDBACK_SUBMITTED: 'employee-help-center-feedback-submitted',
  TICKET_CENTER_CLICKED: 'InAppSupport_TicketCenter_Clicked',
  TICKET_CENTER_TICKET_CLICKED: 'InAppSupport_TicketCenter_Ticket_Clicked',
  TICKET_CENTER_TICKET_MESSAGE_SENT: 'InAppSupport_TicketCenter_Message_Sent',
  TICKET_CENTER_TAB_CLICKED: 'InAppSupport_TicketCenter_TicketTab_Clicked',
  TICKET_CENTER_NO_OPEN_TICKETS_VIEWED:
    'InAppSupport_TicketCenter_NoOpenTickets_Viewed',
};

export const ESCALATION_POLICY_URL =
  'https://help.plumhq.com/en/articles/61-Support-escalation-policy';

/** Gold sparkle icon shown on the "chat with a bot" CTA cards. */
export const CHAT_BOT_ICON_URL =
  'https://storage.googleapis.com/plum-public-assets/Policy-GPT.webp';

/**
 * It is used to Open a website in mobile's default browser - Outside app
 */
export const APP_DEEPLINK_OUTSIDE_BASE_URL = 'employee://plumhq/weboutside?id=';
/**
 * To open any native screen
 */
export const APP_DEEPLINK_BASE_URL = 'employee://plumhq';

export const ALLOWED_PARENT_ORIGINS = IS_DEVELOPMENT_ENV
  ? ['http://localhost:3000', 'http://localhost:5173']
  : [
    'https://app.plumhq.com',
    'https://staging.plumhq.com',
    'https://staging-claims.plumhq.com',
    'https://pre-prod-gpt.plumhq.com',
    'https://my-staging.plumhq.com',
    'https://my.plumhq.com',
    // AWS pre-prod hosts for the claims / app shells that embed this app.
    'https://my-aws.plumhq.com',
    'https://app-aws.plumhq.com',
  ];


export const CTA_LINKS = {
  imtcTicket: ({
    nodeId,
    articleId,
    category,
    subCategory,
    title,
  }: ITicketProps) =>
    `/support/raise-a-imtc-query/${nodeId}?source=ARTICLE&articleId=${articleId}&t_topic=${title}&category=${category}&sub_category=${subCategory ?? ''}&article_name=${title}`,

  support: ({
    nodeId,
    articleId,
    category,
    subCategory,
    title,
  }: ITicketProps) =>
    `/support/raise-a-query/${nodeId}?source=ARTICLE&articleId=${articleId}&t_topic=${title}&category=${category}&sub_category=${subCategory ?? ''}&article_name=${title}`,

  botFramework: ({
    botName,
    webview = false, // Default value for webview
  }: {
    botName: string;
    webview?: boolean; // Make webview optional
  }) =>
    `${AppConfig.CHAT_FRAMEWORK_BASE_URL}/bot/${botName}?parent=support-center${webview ? '&webview=true' : ''}`,
};

export const COOKIE_CONFIG = {
  domain: IS_DEVELOPMENT_ENV ? 'localhost' : '.plumhq.com',
  secure: true,
};

export const HEALTH_CHECKUP_UPCOMING_STATUSES: EHealthCheckupBookingStatus[] = [
  EHealthCheckupBookingStatus.SCHEDULED,
  EHealthCheckupBookingStatus.PARTNER_ASSIGNED,
  EHealthCheckupBookingStatus.RESCHEDULED,
  EHealthCheckupBookingStatus.PENDING,
];

export const HEALTH_CHECKUP_PAST_STATUSES: EHealthCheckupBookingStatus[] = [
  EHealthCheckupBookingStatus.SAMPLE_COLLECTED,
  EHealthCheckupBookingStatus.PROCESSING,
  EHealthCheckupBookingStatus.COMPLETED,
  EHealthCheckupBookingStatus.REPORTS_AVAILABLE,
  EHealthCheckupBookingStatus.FAILED,
  EHealthCheckupBookingStatus.CANCELLED,
];